import React from 'react';

import { TableCell, TableRow, TableHead } from '@material-ui/core';
import PropTypes from 'prop-types';
import HeaderLabelIcons from 'screens/Team/TeamTasksListView/HeaderLabelIcons';
import styled, { css } from 'styled-components';
import { StyledBox, StyledTypography } from 'styles/common';

const TableHeader = ({
  headerList,
  variant = 'body2',
  color = 'textSecondary',
  weight = 600,
  headerBoxJustify = 'center',
}) => (
  <TableHead>
    <TableRow>
      {headerList.map(({ id, title, width, fixedWidth = 0, isSortable, orderBy, handleSort }) => (
        <StyledTableCell
          variant="head"
          key={`header-${id}`}
          fixedWidth={fixedWidth}
          width={width}
          onClick={isSortable ? () => handleSort(id, orderBy) : null}
        >
          <StyledBox display="flex" justifyContent={headerBoxJustify}>
            {/* Move following typography out and accept a generic component to render in its place. */}
            <StyledTypography variant={variant} color={color} weight={weight}>
              {title}
            </StyledTypography>
            {isSortable && (
              <StyledHeaderLabelIcons
                orderBy={orderBy.columnId}
                headCell={{ id }}
                order={String(orderBy.orderType).toLowerCase()}
              />
            )}
          </StyledBox>
        </StyledTableCell>
      ))}
    </TableRow>
  </TableHead>
);

TableHeader.propTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })
);

const StyledTableCell = styled(TableCell)`
  border-color: ${(props) => props.theme.palette.borders.lightGrey};
  ${(props) =>
    props.border &&
    css`
      border: ${props.border};
    `};
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
      max-width: ${props.width};
    `};
  ${(props) =>
    props.fixedWidth &&
    css`
      width: ${props.fixedWidth};
    `}
`;

const StyledHeaderLabelIcons = styled(HeaderLabelIcons)`
  margin-top: -4px;
  cursor: pointer;
`;

export default TableHeader;
